import { gql } from '@apollo/client';

export const LOAD_DATA = gql`
  query Dashboard($date: DateTime!) {
    windFacility: getFacilityById(facilityId: "6299d037762f99000896f5c6") {
      production: readings(
        readingInput: {
          readingType: Pac
          date: $date
          readingPeriod: DAY
          readingAggregation: AVG
          readingResolution: QUARTERHOURLY
        }
      ) {
        unit
        readings {
          date
          value
        }
      }
    }
    solarFacility: getFacilityById(facilityId: "628df1b78509b90009e1f1e6") {
      production: readings(
        readingInput: {
          readingType: Pac
          date: $date
          readingPeriod: DAY
          readingAggregation: AVG
          readingResolution: QUARTERHOURLY
        }
      ) {
        unit
        readings {
          date
          value
        }
      }
    }
    biomassFacility: getFacilityById(facilityId: "6299d00fc0ef420009a44c64") {
      production: readings(
        readingInput: {
          readingType: energy
          date: $date
          readingPeriod: DAY
          readingAggregation: AVG
          readingResolution: QUARTERHOURLY
        }
      ) {
        unit
        readings {
          date
          value
        }
      }
    }
    village: getFacilityById(facilityId: "6299d4f229f4320008ba90b8") {
      consumption: readings(
        readingInput: {
          readingType: Pac
          date: $date
          readingPeriod: DAY
          readingAggregation: AVG
          readingResolution: QUARTERHOURLY
        }
      ) {
        unit
        readings {
          date
          value
        }
      }
    }
  }
`;
